import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { Ref } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteQueryKeys } from "@/data/api/site-query-keys";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";
import { SiteSectionMutationKeys } from "@/data/api/v4b/site-section/site-section-mutation-keys";
import { SiteSectionId, V4HSiteId } from "@/data/common/ids";

export function useDeleteSiteSectionMutation(siteId: Ref<V4HSiteId>, sectionId: Ref<SiteSectionId | undefined>) {
  const queryClient = useQueryClient();
  const v4bClientSdk = useServices().v4b.clientSdk;

  return useMutation({
    mutationKey: sectionId.value ? SiteSectionMutationKeys.delete(siteId, sectionId.value) : undefined,
    mutationFn: () => {
      if (!sectionId.value) {
        throw new Error("Section ID is required");
      }

      return v4bClientSdk.siteSection.delete(siteId.value, sectionId.value);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: SiteQueryKeys.sections(siteId),
      });

      await queryClient.removeQueries({
        queryKey: SiteProgrammingRangeQueryKeys.findPlanning(siteId),
      });
    },
    retry: false,
  });
}
